/**
 * Eine Seite im Scan-Stapel — vom Auslösen bis zum Hochladen.
 *
 * Die Quelle (ganzes Kamerabild bzw. Originaldatei) bleibt erhalten, damit
 * „Anpassen", „Filter" und „Drehen" jederzeit neu von der vollen Auflösung
 * rechnen — nie vom bereits verkleinerten Ergebnis.
 */
import type { Ecken, Filter } from "./bild";
import type { Drehung, RenderErgebnis } from "./render";

export const SCANNER_VERSION = "0.7.0";
export const MAX_SEITEN = 12;

/** Telemetrie je Seite (landet unter beleg.scan_konfidenz->'capture'). */
export type SeitenMeta = {
  /** Bildmaße der Aufnahme */
  w: number;
  h: number;
  /** Schärfe (Skala ab 0.7: 0,05 matschig … 0,4 scharf; 2 Nachkommastellen) */
  sharp: number;
  /** Beleg automatisch gefunden (sonst Standardrahmen) */
  detected: boolean;
  /** Anteil des Belegs am Bild (0..1) */
  areaFrac: number;
  /** serie = schärfstes aus Videobildern, foto = echtes Foto (Android), datei = gewählt */
  mode: "serie" | "foto" | "datei";
  /** Anzahl gemessener Bilder in der Serie */
  frames?: number;
  /** Format der Telemetrie (2 = Scanner 0.7) */
  v: 2;
};

export type CaptureMeta = {
  video: { w: number; h: number };
  scanner: string;
  pages: SeitenMeta[];
};

export type NeueSeite = {
  quelle: Blob;
  w: number;
  h: number;
  ecken: Ecken;
  erkannt: boolean;
  unscharf: boolean;
  vorschau: string;
  meta: SeitenMeta;
};

export type ScanSeite = NeueSeite & {
  id: string;
  drehung: Drehung;
  filter: Filter;
  /** fertig gerechnete Seite (null = rechnet noch) */
  ergebnis: (RenderErgebnis & { url: string }) | null;
  /** zählt jede Änderung hoch — ein altes Rechenergebnis wird verworfen */
  stand: number;
  fehler?: string;
};

let laufnummer = 0;
export function neueId(): string {
  laufnummer += 1;
  return `s${Date.now().toString(36)}${laufnummer}`;
}

export const FILTER_NAMEN: Record<Filter, { name: string; info: string }> = {
  dokument: { name: "Dokument", info: "Graustufen, ohne Schatten" },
  farbe: { name: "Farbe", info: "Wie Dokument, farbig" },
  original: { name: "Original", info: "Unverändert" },
};
